import { render, staticRenderFns } from "./FlatSelect.vue?vue&type=template&id=6fabbe2d&"
import script from "./FlatSelect.vue?vue&type=script&lang=js&"
export * from "./FlatSelect.vue?vue&type=script&lang=js&"
import style0 from "./FlatSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports